/* eslint-disable no-use-before-define */
/* eslint-disable no-console */

import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import Thunk from 'redux-thunk'
import { resetAuth, /*refreshTokenSuccess,*/ loginRequestError } from 'features/Authentication/redux/authActions'
import reducers from './reducers';

// BFF Authentication:
// - Tokens are managed server-side via HTTP-only cookies
// - Frontend only stores user data and auth status
// - No client-side JWT handling or token expiry checks
// - Session validation handled by BFF on each request
const store = createStore(
  reducers, 
  composeWithDevTools(
    applyMiddleware(Thunk)
  )
);

// Cookie-based authentication with Lambda authorizer
// All API requests automatically include cookies via withCredentials
// No client-side token management needed

export default store;
